import { h, Component } from 'preact'

import { connect } from 'app/store'
import { api } from 'app/util/api'

import Input from 'app/components/Input'
import Form from 'app/components/Form'
import Button from 'app/components/Button'
import linkState from 'linkstate'

class ForgotPassword extends Component {
  state = {
    email: '',
    submitted: false,
  }

  submit = async () => {
    const { email } = this.state

    await api.post('/auth/reset-token', { email })

    this.setState({ submitted: true })
  }

  render() {
    const { email, submitted } = this.state

    return (
      <div>
        <h3 class="mb-5">Reset password</h3>
        <Form onSubmit={() => this.submit()}>
          <Input
            label="Email"
            value={email}
            type="email"
            class="mb-3 w-100"
            required
            disabled={submitted}
            onInput={linkState(this, 'email')}
          />
          {submitted ? (
            <div class="text-right">
              <p>Done!</p>
              <p>Check your email for instructions</p>
            </div>
          ) : (
            <Button type="submit" class="float-right">
              Send reset email
            </Button>
          )}
        </Form>
      </div>
    )
  }
}

export default connect(
  null,
  ForgotPassword,
)



// WEBPACK FOOTER //
// ./pages/ForgotPassword.js